module.exports = __webpack_public_path__ + "img/2_2.ff840317.png";